import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { carouselConfig, tokens } from '../../constants';
import { isValidObject } from '../../utils';
var generateCarouselBreakpoints = breakpoints => {
  if (!isValidObject(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.xs)) {
    Object.assign(breakpoints, {
      xs: {
        slidesPerPage: 1,
        slidesToScroll: 1,
        itemSpacing: 8,
        seekGap: 0,
        firstSeekGapSpacing: 0,
        lastSeekGapSpacing: 0
      }
    });
  }
  if (!isValidObject(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.sm)) breakpoints.sm = Object.assign({}, breakpoints.xs);
  if (!isValidObject(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.md)) breakpoints.md = Object.assign({}, breakpoints.sm);
  if (!isValidObject(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.lg)) breakpoints.lg = Object.assign({}, breakpoints.md);
  if (!isValidObject(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.xl)) breakpoints.xl = Object.assign({}, breakpoints.lg);
  return breakpoints;
};
export var getCarouselStyles = props => {
  var _props$indicatorPosit = props.indicatorPosition,
    indicatorPosition = _props$indicatorPosit === void 0 ? 'bottom-center' : _props$indicatorPosit,
    _props$indicatorTopPo = props.indicatorTopPosition,
    indicatorTopPosition = _props$indicatorTopPo === void 0 ? 12 : _props$indicatorTopPo,
    _props$indicatorBotto = props.indicatorBottomPosition,
    indicatorBottomPosition = _props$indicatorBotto === void 0 ? 12 : _props$indicatorBotto,
    _props$indicatorRight = props.indicatorRightPosition,
    indicatorRightPosition = _props$indicatorRight === void 0 ? 12 : _props$indicatorRight;
  return StyleSheet.create({
    outerContainer: {
      position: 'relative'
    },
    container: {
      overflow: 'hidden',
      position: 'relative',
      top: 0
    },
    swipeArea: {
      flexDirection: 'row'
    },
    indicatorContainer: Object.assign({
      position: 'absolute',
      flexDirection: 'row',
      alignSelf: 'center'
    }, indicatorPosition === 'bottom-center' ? {
      bottom: indicatorBottomPosition
    } : {
      right: indicatorRightPosition,
      top: indicatorTopPosition
    }),
    carouselButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    innerContainer: {
      paddingHorizontal: tokens.spacing.SPACING_16,
      flex: 0.999
    },
    navigationSlideCounter: {
      marginTop: tokens.spacing.SPACING_12,
      alignSelf: 'center'
    },
    navigationWithButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      marginTop: tokens.spacing.SPACING_32
    },
    counter: {
      marginHorizontal: tokens.spacing.SPACING_80
    }
  });
};
export var getAnimatedCarouselContainerStyle = (left, width) => {
  return {
    left,
    width
  };
};
export var getAnimatedCarouselSwipeAreaStyle = animatedXPosition => {
  return {
    width: '100%',
    transform: [{
      translateX: animatedXPosition
    }]
  };
};
export var getCarouselProps = (props, context) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(carouselConfig === null || carouselConfig === void 0 ? void 0 : carouselConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.carousel) === null || _a === void 0 ? void 0 : _a[theme]);
  var updatedBreakPoints = generateCarouselBreakpoints({
    xl: Object.assign(Object.assign({}, (_b = configProps === null || configProps === void 0 ? void 0 : configProps.breakPoints) === null || _b === void 0 ? void 0 : _b.xl), (_c = props === null || props === void 0 ? void 0 : props.breakPoints) === null || _c === void 0 ? void 0 : _c.xl),
    lg: Object.assign(Object.assign({}, (_d = configProps === null || configProps === void 0 ? void 0 : configProps.breakPoints) === null || _d === void 0 ? void 0 : _d.lg), (_e = props === null || props === void 0 ? void 0 : props.breakPoints) === null || _e === void 0 ? void 0 : _e.lg),
    md: Object.assign(Object.assign({}, (_f = configProps === null || configProps === void 0 ? void 0 : configProps.breakPoints) === null || _f === void 0 ? void 0 : _f.md), (_g = props === null || props === void 0 ? void 0 : props.breakPoints) === null || _g === void 0 ? void 0 : _g.md),
    sm: Object.assign(Object.assign({}, (_h = configProps === null || configProps === void 0 ? void 0 : configProps.breakPoints) === null || _h === void 0 ? void 0 : _h.sm), (_j = props === null || props === void 0 ? void 0 : props.breakPoints) === null || _j === void 0 ? void 0 : _j.sm),
    xs: Object.assign(Object.assign({}, (_k = configProps === null || configProps === void 0 ? void 0 : configProps.breakPoints) === null || _k === void 0 ? void 0 : _k.xs), (_l = props === null || props === void 0 ? void 0 : props.breakPoints) === null || _l === void 0 ? void 0 : _l.xs)
  });
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    breakPoints: updatedBreakPoints
  });
};